import React from "react";
import PropTypes from "prop-types";

import MobileCardBlock from "./MobileCardBlock";

function MobileBlock({
  firstHalls,
  secondHalls,
  activeMediaSize,
  activeHallId,
  setActiveHallId,
  ClubHallDescription,
}) {
  return (
    <>
      <div className="club-halls-mob">
        {firstHalls.map(({ id, title, image, imageTitleEnabled }) => (
          <MobileCardBlock
            key={id}
            activeMediaSize={activeMediaSize}
            id={id}
            activeHallId={activeHallId}
            setActiveHallId={setActiveHallId}
            image={image}
            title={title}
            imageTitleEnabled={imageTitleEnabled}
          />
        ))}
      </div>

      {ClubHallDescription}

      {!!secondHalls?.length && (
        <div className="club-halls-mob">
          {secondHalls.map(({ id, title, image, imageTitleEnabled }) => (
            <MobileCardBlock
              key={id}
              activeMediaSize={activeMediaSize}
              id={id}
              activeHallId={activeHallId}
              setActiveHallId={setActiveHallId}
              image={image}
              title={title}
              imageTitleEnabled={imageTitleEnabled}
            />
          ))}
        </div>
      )}
    </>
  );
}

MobileBlock.propTypes = {
  firstHalls: PropTypes.array,
  secondHalls: PropTypes.array,
  countBlocks: PropTypes.array,
  activeHallId: PropTypes.number,
  setActiveHallId: PropTypes.func,
  activeMediaSize: PropTypes.object,
};

MobileBlock.defaultProps = {
  firstHalls: [],
  secondHalls: [],
  countBlocks: [],
  activeHallId: -1,
  setActiveHallId: () => {},
  activeMediaSize: {},
};

export default MobileBlock;
